/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import {useScope as createI18nScope} from '@canvas/i18n'
import {GenericErrorPage} from '@instructure/platform-generic-error-page'
import {reportError, canvasErrorPageTranslations} from '@canvas/error-page-utils'
import ErrorShip from '@instructure/platform-images/assets/ErrorShip.svg'
import {ScanHandler} from './ScanHandler'
import type {ScanViewProps} from '../types'

const I18n = createI18nScope('accessibility_scan')

export const LastScanFailedResultView: React.FC<ScanViewProps> = ({
  handleCourseScan,
  isRequestLoading,
  buttonLabel,
}) => {
  return (
    <ScanHandler
      handleCourseScan={handleCourseScan}
      scanButtonDisabled={isRequestLoading}
      buttonLabel={buttonLabel}
    >
      <GenericErrorPage
        imageUrl={ErrorShip}
        onReportError={reportError}
        translations={canvasErrorPageTranslations}
        errorSubject={I18n.t('Last accessibility content scan failed.')}
        errorCategory={I18n.t('Accessibility Scan Error Page.')}
        errorMessage={I18n.t('Try to scan again.')}
      />
    </ScanHandler>
  )
}
